/**
 * AppShell - Unified Adaptive Layout Shell
 *
 * Wraps all routes with responsive navigation that adapts from desktop to mobile
 */
import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigationStack } from '../../contexts/NavigationContext';
import DesktopNav from '../navigation/DesktopNav';
import MobileStackNav from '../navigation/MobileStackNav';
import PageTransition from '../navigation/PageTransition';
import { AuthGate } from '../AuthGate';
import Footer from '../Footer';
import './AppShell.css';

const AppShell = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const { modalStack, closeModal } = useNavigationStack();

  // Check if current page should hide navigation (e.g., analyzing page)
  const hideNav = location.pathname === '/analyzing';

  const handleCameraInput = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Handle camera input - this will be wired to the search flow
    const imagePreview = URL.createObjectURL(file);
    console.log('Camera input received:', file.name);

    // You can emit an event or use navigation context to handle this
    window.dispatchEvent(new CustomEvent('camera-upload', {
      detail: { file, imagePreview }
    }));
  };

  return (
    <div className="app-shell">
      {/* Header */}
      {!hideNav && (
        <header className="app-header">
          <div className="app-header-inner">
            <Link to="/" className="app-logo">
              <svg className="app-logo-icon" viewBox="0 0 100 100" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="50,6 90,28 90,72 50,94 10,72 10,28" />
                <line x1="50" y1="6" x2="50" y2="50" />
                <line x1="90" y1="28" x2="50" y2="50" />
                <line x1="90" y1="72" x2="50" y2="50" />
                <line x1="50" y1="94" x2="50" y2="50" />
                <line x1="10" y1="72" x2="50" y2="50" />
                <line x1="10" y1="28" x2="50" y2="50" />
              </svg>
            </Link>
            <DesktopNav />
          </div>
        </header>
      )}

      {/* Main Content with Page Transitions */}
      <main className={`app-main${location.pathname === '/chat/leo' ? ' app-main-chat' : ''}`}>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>

      {/* Footer */}
      {!hideNav && <Footer />}

      {/* Mobile Navigation */}
      {!hideNav && <MobileStackNav />}

      {/* Modal Stack */}
      {modalStack.map((modal) => (
        <div key={modal.id} className="modal-overlay">
          {React.cloneElement(modal.component, {
            isOpen: true,
            onClose: () => closeModal(modal.id),
            ...modal.options
          })}
        </div>
      ))}

      {/* Hidden camera input for mobile nav */}
      <input
        type="file"
        id="app-camera-input"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={handleCameraInput}
      />
    </div>
  );
};

export default AppShell;


